var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-list',{attrs:{"data":_vm.data,"columns":_vm.column,"page":_vm.page,"table-style":{ name: 'mixture' },"page-size":_vm.page.pageSize,"loading":_vm.loading},on:{"page-size-changed":_vm.pageSizeChanged,"page-changed":_vm.pageChanged,"sort-change":_vm.sortChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }